module.exports = ".sortable {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none; }\n\n.checkbox-col {\n  width: 32px;\n  text-align: center; }\n\n.actions-col {\n  white-space: nowrap;\n  width: 80px; }\n\n.table-responsive {\n  overflow-x: auto; }\n\n.table-sm {\n  font-size: 13px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/email/segments/segments.component.scss
// module id = ./src/app/modules/email/segments/segments.component.scss
// module chunks = main